 <template>
  <div id="footer">
    <span id="copyright">	&copy;{{year}} Salesforce.com</span>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'dashboard-footer',
  computed: {
    year() {
      return moment().format('YYYY');
    }
  },
  data () {
    return {
    }
  }
};
</script>

<style>

#footer {
  position: relative;
  height: 300px;
  padding: 60px;
  background: #ffffff;
}

#copyright {
  position: absolute;
  font-size: 0.8em;
  padding: 1em;
  bottom: 0;
  left: 0;
  width: 100%;
  opacity: 0.8;
}

</style>



// WEBPACK FOOTER //
// DashboardFooter.vue?bad50fd8